import { html, nothing } from "lit";

export type FilesProps = {
  loading: boolean;
  files: Array<{ name: string; size: number; mime_type: string; source: string }>;
  error: string | null;
  onRefresh: () => void;
  onDownload: (filename: string) => void;
  onDelete: (filename: string) => void;
};

function formatFileSize(bytes: number): string {
  if (bytes === 0) return "0 B";
  const units = ["B", "KB", "MB", "GB"];
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  const value = bytes / Math.pow(1024, i);
  return `${value < 10 ? value.toFixed(1) : Math.round(value)} ${units[i]}`;
}

function fileIcon(mimeType: string): string {
  if (mimeType.startsWith("application/pdf")) return "PDF";
  if (mimeType.startsWith("text/")) return "TXT";
  if (mimeType.startsWith("image/")) return "IMG";
  if (mimeType.includes("json")) return "JSON";
  if (mimeType.includes("javascript") || mimeType.includes("typescript")) return "JS";
  if (mimeType.includes("html")) return "HTML";
  if (mimeType.includes("csv") || mimeType.includes("spreadsheet")) return "CSV";
  return "FILE";
}

export function renderFiles(props: FilesProps) {
  return html`
    <section>
      <div class="card">
        <div class="card-title" style="display:flex;align-items:center;justify-content:space-between">
          <span>Files</span>
          <button class="btn btn-sm" @click=${props.onRefresh} ?disabled=${props.loading}>
            ${props.loading ? "Loading..." : "Refresh"}
          </button>
        </div>

        ${props.error
          ? html`<div class="pill danger" style="margin-bottom:0.75rem">${props.error}</div>`
          : nothing}

        ${props.loading && props.files.length === 0
          ? html`<div style="padding:2rem;text-align:center;opacity:0.5">Loading files...</div>`
          : props.files.length === 0
            ? html`<div style="padding:2rem;text-align:center;opacity:0.5">
                No files yet. Files created by your agent will appear here.
              </div>`
            : html`
                <div class="files-list">
                  ${props.files.map(
                    (file) => html`
                      <div class="files-row">
                        <div class="files-row__icon">
                          <span class="files-type-badge">${fileIcon(file.mime_type)}</span>
                        </div>
                        <div class="files-row__info">
                          <div class="files-row__name">${file.name}</div>
                          <div class="files-row__meta">
                            ${formatFileSize(file.size)}
                            ${file.source === "upload" ? html` <span class="pill" style="font-size:0.65rem;padding:0.1rem 0.4rem">uploaded</span>` : nothing}
                          </div>
                        </div>
                        <div class="files-row__actions">
                          <button
                            class="btn btn-sm"
                            @click=${() => props.onDownload(file.name)}
                            title="Download"
                          >Download</button>
                          <button
                            class="btn btn-sm btn-danger"
                            @click=${() => {
                              if (confirm("Delete \"" + file.name + "\"?")) {
                                props.onDelete(file.name);
                              }
                            }}
                            title="Delete"
                          >Delete</button>
                        </div>
                      </div>
                    `,
                  )}
                </div>
              `}
      </div>
    </section>
  `;
}
